var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"language-switcher"},[_c('ol',_vm._l((_vm.languages),function(lang,index){return _c('li',{key:lang.value},[_c('router-link',{attrs:{"to":_vm.getTranslatedRoute(lang.value)}},[_vm._v(" "+_vm._s(lang.value)+" ")]),(index < _vm.languages.length - 1)?_c('span',[_vm._v("|")]):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }